import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/pro-solid-svg-icons/faCircleUser';
import { clsx } from 'clsx';
import { FunctionComponent } from 'react';
import styles from './UnassignedAvatar.module.scss';

interface UnassignedAvatarProps {
    className?: string;
}

export const UnassignedAvatar: FunctionComponent<UnassignedAvatarProps> = props => {
    return (
        <FontAwesomeIcon
            icon={faCircleUser}
            className={clsx(styles.unassignedAvatar, props.className)}
        />
    );
};

export default UnassignedAvatar;
